import { gql } from 'graphql-request'

export const getUser = gql`
  {
    me {
      id
      email
      name
      roles {
      }
    }
  }
`

export const userAdmin = gql`
  query isUserAdmin {
    isUserAdmin
  }
`
